import { LogOut, UserPlus } from "lucide-react";
import * as React from "react";

import { DropdownMenuGroup, DropdownMenuItem } from "@/components/ui/dropdown";

interface AccountActionsProps {
  onReferFriend: () => void;
  onLogout: () => void;
}

export const AccountActions: React.FC<AccountActionsProps> = ({ onReferFriend, onLogout }) => (
  <DropdownMenuGroup>
    <DropdownMenuItem
      onClick={onReferFriend}
      className="mx-1 gap-2 rounded-md px-2 py-1.5 text-gray-600"
    >
      <UserPlus className="size-3.5" />
      <span className="text-sm">Refer a friend</span>
    </DropdownMenuItem>
    <DropdownMenuItem
      onClick={onLogout}
      className="mx-1 gap-2 rounded-md px-2 py-1.5 text-red-600 focus:bg-red-50 focus:text-red-600"
    >
      <LogOut className="size-3.5" />
      <span className="text-sm">Log out</span>
    </DropdownMenuItem>
  </DropdownMenuGroup>
);
